import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";
import SubHeader from "../../components/SubHeader/SubHeader";
import MenuButton from "../../components/MenuButton/MenuButton";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import { APPOINTMENT_TYPES } from "../../config/setting";
import "../../styles/globals.css";
import "./AppointmentSelectPage.css";

/**
 * 初診・再診選択画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function AppointmentSelectPage() {
  const {
    globalMedicalInstitutionName,
    setGlobalSelectAppointment,
    globalMedicalInstitutionId,
  } = useContext(AppContext);
  const navigate = useNavigate();

  /**
   * コンポーネントがマウントされた時にデータを取得
   */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /**
   * メニューボタンクリック時
   * @param {APPOINTMENT_TYPES} type - 予約の種類
   * @return {}  なし
   */
  const handleMenuClick = (type) => {
    // 保持
    setGlobalSelectAppointment(type);

    // 日時選択画面に遷移
    navigate("/datetime-select");
  };

  /**
   * 戻るボタンクリック時
   * @param {} なし
   * @return {}  なし
   */
  const handleBackClick = () => {
    // 予約メニュー画面に遷移
    navigate(
      `/reservation-menu#medicalInstitutionId=${globalMedicalInstitutionId}`
    );
  };

  return (
    <div className="appointment-select">
      <SubHeader clinicName={globalMedicalInstitutionName} />
      <div className="main-area">
        <div className="title">初再診を選択</div>
        <div className="menu-buttons">
          <MenuButton
            key={APPOINTMENT_TYPES.FIRST_VISIT.id}
            className="menu-button"
            buttonLabel={APPOINTMENT_TYPES.FIRST_VISIT.name}
            underSubLabel={"前回と違う症状"}
            onClick={() => handleMenuClick(APPOINTMENT_TYPES.FIRST_VISIT)}
          />
          <MenuButton
            key={APPOINTMENT_TYPES.FOLLOW_UP.id}
            className="menu-button"
            buttonLabel={APPOINTMENT_TYPES.FOLLOW_UP.name}
            underSubLabel={"前回と同じ症状"}
            onClick={() => handleMenuClick(APPOINTMENT_TYPES.FOLLOW_UP)}
          />
        </div>
        <GeneralButton
          buttonLabel={"予約メニュー選択に戻る"}
          type={"secondary-white"}
          onClick={() => handleBackClick()}
        />
      </div>
    </div>
  );
}

export default AppointmentSelectPage;
